import { apiClient, handleResponse } from './axios';

async function getQuestions() {
  try {
    const response = await apiClient.get('/question');
    const questions = await handleResponse(response);
    return questions;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function getQuestionPoolsWithQuestions() {
  try {
    const response = await apiClient.get('/qpool/questions');
    const pools = await handleResponse(response);
    return pools;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function getQuestionPoolWithQuestions(id) {
  try {
    const response = await apiClient.get(`/qpool/questions/${id}`);
    const pools = await handleResponse(response);
    return pools;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function updateQuestion(id, body) {
  try {
    const response = await apiClient.put(`/question/${id}`, body);
    const semester = await handleResponse(response);
    return semester;
  } catch (error) {
    return error.response;
  }
}

async function addQuestion(body) {
  try {
    const response = await apiClient.post('/question', body);
    const semester = await handleResponse(response);
    return semester;
  } catch (error) {
    return error.response;
  }
}

async function updateQuestionPool(body, qpoolId) {
  try {
    const response = await apiClient.put(`/qpool/questions/${qpoolId}`, body);
    const semester = await handleResponse(response);
    return semester;
  } catch (error) {
    return error.response;
  }
}

async function addQuestionPool(body) {
  try {
    const response = await apiClient.post('/qpool', body);
    const questionPool = await handleResponse(response);
    return questionPool;
  } catch (error) {
    return error.response;
  }
}

async function deleteQuestionPool(questionPoolId) {
  try {
    const response = await apiClient.delete(`/qpool/${questionPoolId}`);
    const questionPool = await handleResponse(response);
    return questionPool;
  } catch (error) {
    return error.response;
  }
}

async function getQuestionPoolsFromQuestion(questionId) {
  try {
    const response = await apiClient.get(`/qpool/question/${questionId}`);
    const questionPool = await handleResponse(response);
    return questionPool;
  } catch (error) {
    return error.response;
  }
}

const questionServices = {
  deleteQuestionPool,
  addQuestionPool,
  addQuestion,
  getQuestions,
  updateQuestionPool,
  getQuestionPoolsWithQuestions,
  getQuestionPoolWithQuestions,
  updateQuestion,
  getQuestionPoolsFromQuestion,
};

export default questionServices;
